import { render, staticRenderFns } from "./camera.vue?vue&type=template&id=1783421d&scoped=true"
import script from "./camera.vue?vue&type=script&lang=js"
export * from "./camera.vue?vue&type=script&lang=js"
import style0 from "./camera.vue?vue&type=style&index=0&id=1783421d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1783421d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1783421d')) {
      api.createRecord('1783421d', component.options)
    } else {
      api.reload('1783421d', component.options)
    }
    module.hot.accept("./camera.vue?vue&type=template&id=1783421d&scoped=true", function () {
      api.rerender('1783421d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/collectionCenter/Operation/carScan/camera.vue"
export default component.exports